const oneDay = 1000 * 60 * 60 * 24;

export function getEndOfToday() {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return new Date(startOfToday.getTime() + oneDay);
}
